import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const projectApi = {
  getProjects: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PROJECTS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  },

  getProjectByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PROJECTS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching project ${identifier}:`, error);
      throw error;
    }
  },

  createProject: async (projectData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.PROJECTS}`, projectData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },

  updateProject: async (identifier, projectData) => {
    try {
      projectData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.PROJECTS}/${identifier}`, projectData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating project ${identifier}:`, error);
      throw error;
    }
  },

  trashProject: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.PROJECTS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing project ${identifier}:`, error);
      throw error;
    }
  },

  restoreProject: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.PROJECTS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring project ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteProject: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.PROJECTS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting project ${identifier}:`, error);
      throw error;
    }
  },

  getProjectSkills: async (projectId) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PROJECTS}/${projectId}/skills`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching skills for project ${projectId}:`, error);
      throw error;
    }
  },
};

export default projectApi;